// extracted by mini-css-extract-plugin
module.exports = {"NavCol":"ConfigurationScreenBase__NavCol__4tI0T"};